export class WireStore {
    constructor(callback) {
        this.callback = callback;
    }
    // deliberate noop: all the magic happens in update
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    connect() { }
    update({ store, selector, equalityFn }) {
        if (!this.subscription ||
            this.store !== store ||
            this.selector !== selector ||
            this.equalityFn !== equalityFn) {
            this.unsubscribeFromStore();
            this.store = store;
            this.selector = selector;
            this.equalityFn = equalityFn;
            this.subscribeToStore();
        }
    }
    disconnect() {
        this.unsubscribeFromStore();
    }
    subscribeToStore() {
        this.subscription = this.store.subscribe(this.callback, this.selector, this.equalityFn);
        this.callback(this.selector ? this.selector(this.store.getState()) : this.store.getState());
    }
    unsubscribeFromStore() {
        if (this.subscription) {
            this.subscription();
            this.subscription = undefined;
        }
    }
}
